import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { fetchCandidateExperiences, postCandidateExperience, deleteCandidateExperience } from '../../api/candidate';
import useFetch from '../../hooks/useFetch';
import Section from '../common/section';
import Experience from '../experience';
import ExperienceForm from '../forms/experience';
import useDebounce from '../../hooks/useDebounce';
import useNotification from '../../hooks/useNotification';
import _ from 'lodash';

const Experiences = ({edit,reloadCandidateUpdatedAtData}) => {
  const { hash } = useParams();
  const [ changes, setChanges ] = useState(false);
  const [ disabled, setDisabled ] = useState(false);
  const { result: experiences } = useFetch(fetchCandidateExperiences, hash, [
    hash, changes
  ]);
  const notifications = useNotification();
  const handleAddExperience = useDebounce(( data) => {
    const experience = {
      company: data.company,
      since: `${data.since.toLocaleString('en-US', { month: 'long' })} ${data.since.getFullYear()}`,
      until: data.until ? `${data.until.toLocaleString('en-US', { month: 'long' })} ${data.until.getFullYear()}` : "Current",
      projects:
        _.flatten(_.map(data.positions,
          (position) => _.flatMap(position.projects,
            (project) => ({
              ...project,
              skills: _.map(project.skills, skill => skill.hash),
              role: position.name
            }))))
    }
    //console.log("experience", experience)
    setDisabled(true);
    postCandidateExperience(hash, { immediately: true, ...experience })
    .then((res) => {
      if(res.success){
        setChanges((prev) => prev + 1);
        reloadCandidateUpdatedAtData()
        notifications.success({
          message: 'Experience was successfully updated',
        });
      } else 
          notifications.error(res.error);
    })
    .finally(() => {
      setDisabled(false);
    })
  }, 1000);

  function handleDeleteExperience(experience) {
    deleteCandidateExperience(hash, { immediately: true, experience }).then((res) => {
      if(res.success){
        setChanges((prev) => prev + 1);
        reloadCandidateUpdatedAtData()
        notifications.success({
          message: 'Experience was successfully deleted',
        });
      } else 
          notifications.error(res.error);
    });
  }

  if (!edit && (!experiences || !Array.isArray(experiences))) return null;

  if (experiences?.length > 1) {
    experiences.forEach(item => { 
      item.orderElem = !isNaN(new Date(item.until).getTime()) 
        ? `${new Date(item.until).getFullYear()}${('0'+(new Date(item.until).getMonth()+1)).slice(-2)}` 
        : `${new Date().getFullYear()}${('0'+(new Date().getMonth()+1)).slice(-2)}`;      
    });
    experiences.sort(function (a, b) {
      return ((a['orderElem'] > b['orderElem']) ? -1 : ((a['orderElem'] < b['orderElem']) ? 1 : 0));
    });
  }

  return (
    <Section title="Experience" /*disabled={!isEnabled}*/>
      {experiences?.length > 0 && experiences.map((experience) => (
        <Experience 
          reloadCandidateUpdatedAtData={reloadCandidateUpdatedAtData}   
          edit={edit} 
          key={experience.hash} 
          onDelete={handleDeleteExperience} 
          {...experience} 
        />
      ))}
      { edit && 
        <ExperienceForm 
          disabled={disabled} 
          onSubmit={handleAddExperience}
        />
      }
    </Section>
  );
};

export default Experiences;
